// React Imports
import { useEffect } from "react";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";

// Utils Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";

// Component Imports
import ICONS from "../../../assets/Icons";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithCTA from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const ReimbursementTxnMultiCard = ({
  filterRef,
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SideDrawerOpen,
  // setDatas,
  setTxnId,
  openBeneTxnDetailModal,
}) => {
  // 1️⃣ useDispatch
  const dispatch = useDispatch();

  // 2️⃣ useState
  // (none – all state from props)

  // 3️⃣ useSelector
  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state?.beneTxnViewAccData);

  // 4️⃣ Callback / Handler functions
  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const handleCardClick = (account) => {
    if (account.beneficiary_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(account.amount);
        const isSelected = prevSelected.includes(account.txn_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          const newData = selectedSendTransactions.filter(
            (val) => val?.txn_id !== account.txn_id,
          );
          setSelectedSendTransactions(newData);
          return prevSelected.filter((id) => id !== account.txn_id);
        }
        if (prevSelected.length < GlobalConfiguration.categorymaxLength) {
          setTotalAmount((prevAmount) => prevAmount + cardAmount);
          setSelectedSendTransactions((prev) => [...prev, account]);
          return [...prevSelected, account.txn_id];
        }
        return prevSelected;
      });
    }
  };

  const handleCtaClick = (e, account) => {
    e.stopPropagation();
    // setDatas(account);

    if (!sessionStorage.getItem("q2p_token")) {
      return;
    }
    if (account.beneficiary_account_approval_status === "pending") {
      SideDrawerOpen(account?.beneficiary_account_id, account.txn_id);
    } else {
      openBeneTxnDetailModal();
      setTxnId(account.txn_id);
    }
  };

  // 5️⃣ useEffect
  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError, dispatch]);

  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((account) => (
          <CardContainer
            filterRef={filterRef}
            hoverHeight={
              GlobalConfiguration?.reimbursementTxnMultiApprovalCardHoverHeight
            }
            isDisabled={
              filterOpen ||
              account.beneficiary_account_approval_status === "pending"
            }
            key={account?.txn_id}
            isSelected={selectedTransactions.includes(account.txn_id)}
            onClickHandler={() => handleCardClick(account)}
            varaint="overlay"
          >
            <card-body>
              <TextWithIcon
                type={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Text"
                    : "Amount"
                }
                fontWeight={"semibold"}
                text={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Account approval pending"
                    : account?.amount
                }
                textColor={getStatusColor(
                  account.beneficiary_account_approval_status,
                )}
                subText={
                  account.beneficiary_account_approval_status === "pending"
                    ? "Account status"
                    : "Amount"
                }
                iconComponentArray={
                  account.beneficiary_account_approval_status !== "pending"
                    ? [
                        ...(account?.confidential_transaction === "Y"
                          ? [
                              {
                                icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                title: "confidential",
                                isDisabled: false,
                              },
                            ]
                          : []),
                        {
                          icon: selectedTransactions.includes(account?.txn_id)
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                          isDisabled: false,
                        },
                      ]
                    : []
                }
              />
              <TextWithIcon
                type={"Text"}
                fontWeight={"var(--font-normal)"}
                text={account.beneficiary_account_name}
                textColor={"var(--text-primary)"}
                subText="Account name"
              />

              <TextWithCTA
                btnText={
                  account?.beneficiary_account_approval_status === "pending"
                    ? "Approve account"
                    : "Reimbursement details"
                }
                enabledBgColor={"var(--text-primary)"}
                enabledTextColor={"var(--primary-bg)"}
                handleFunction={(e) => handleCtaClick(e, account)}
                icon={ICONS?.ARROW_RIGHT_WHITE}
                isDisabled={!!filterOpen}
                text={
                  account.created_on
                    ? formatDateViewAll(account.created_on, false, false)
                    : "Not given"
                }
                subText="Date"
                type={"Text"}
              />
            </card-body>
            <card-hover>
              <TextWithIcon
                text={account?.labels?.join(", ") || "Not  assigned "}
                fontWeight={"normal"}
                textColor={"var(--text-primary)"}
                iconComponentArray={[
                  {
                    icon: ICONS?.LABEL,
                  },
                ]}
              />
            </card-hover>
          </CardContainer>
        ))}
      </div>
    </>
  );
};

export default ReimbursementTxnMultiCard;
